import TestimonialCard from '../../../components/feature/TestimonialCard';
import TrustMetrics from '../../../components/feature/TrustMetrics';
import { testimonials } from '../../../mocks/testimonials';

export default function Testimonial() {
  // Show first 3 testimonials
  const featuredTestimonials = testimonials.slice(0, 3);

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-star-fill"></i>
            Trusted by Australian Tradies
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Real Results from Real Tradies
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of Australian tradies who've transformed their business with MTA Planner Pro
          </p>
        </div>

        {/* Trust Metrics */}
        <div className="mb-16">
          <TrustMetrics />
        </div>

        {/* Testimonials Grid */}
        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {featuredTestimonials.map((testimonial) => (
            <TestimonialCard
              key={testimonial.id}
              name={testimonial.name}
              trade={testimonial.trade}
              location={testimonial.location}
              rating={testimonial.rating}
              image={testimonial.image}
              quote={testimonial.quote}
              jobsCompleted={testimonial.jobsCompleted}
              timeUsing={testimonial.timeUsing}
            />
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="/signup"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Start Your Free Trial
            <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-sm text-gray-600 mt-4">
            No credit card required • 14-day free trial • Cancel anytime
          </p>
        </div>
      </div>
    </section>
  );
}